import { TabInterface } from "components/layout/interfaces";
import Tabs from "components/layout/tabs";
import View from "components/layout/view";
import Title from "components/title";
import { parse } from "lib/locale";
import { FunctionComponent } from "react";
import { useList } from "stores/hooks/list";
import { useLocale } from "stores/hooks/locale";
import InviationsTab from "./tabs/invitations/invitations-tab";
import UsersTab from "./tabs/users/users-tab";
import BaseTab from "./tabs/base/base-tab";
import ReportingTab from "./tabs/reporting/reporting-tab";
import LogTab from "./tabs/log/log-tab";
import EntitiesTab from "./tabs/entities/entities-tab";

const AdminListView: FunctionComponent = () => {
  const list = useList();
  const locale = useLocale();

  if (!list) {
    return null;
  }

  const tabs: TabInterface[] = [
    { key: "users", label: "Ilmoitusvelvolliset", render: () => <UsersTab /> },
    {
      key: "invitations",
      label: "Kutsut ja muistutukset",
      render: () => <InviationsTab />,
    },
    {
      key: "base",
      label: "Asetukset",
      render: () => <BaseTab />,
    },
    {
      key: "entities",
      label: "Luettelon rakenne",
      render: () => <EntitiesTab />,
    },
    {
      key: "reporting",
      label: "Raportointi",
      render: () => <ReportingTab />,
    },
    {
      key: "log",
      label: "Historia",
      render: () => <LogTab />,
    },
  ];

  let title = parse(list.name, locale);
  if (list.archived) {
    title += " [arkistoitu]";
  }

  return (
    <View title={title}>
      <Title>{title}</Title>
      <Tabs name={`list-${list.uuid}`} tabs={tabs} />
    </View>
  );
};

export default AdminListView;
